import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
// import GD from "../RestAPI/getData";
import language from '../../../../assets/languages/language';
import ModalComponent from '../../../Common/Modal';
import PDFModelComponent from '../../../Common/PDFModel';
import FrmSubscriptionCheck from '../../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../../RestAPI/PartnerSubscription/FrmSubscription';
import AlertMessage from '../../../config/alertMessage';
// import { getDeviceDetails } from "../../common/deviceDetails";
import { getIpAddress } from '../../../../common/getIpAddress';
/* eslint-disable*/
class FrmReadings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      PDF_Alert_status: false,
      PDFDownloadAlertStatus: false,
      MessageTitle: `${language.LC().MESSAGE}`,
      MessageContent: `${language.LC().QUESTION_NOT_FOUND}`,
      PDFMessageTitle: App_data.messageTitle_frm,
      PDFMessageContent: AlertMessage.messageContent_frm,
      readings: [],
      token: '',
      idname: '',
      chapterid: this.props.params.chapter,
      chapterName: '',
      ValidToken: false,
      chapter_id: '',
      selectedmenufrm: 'frm',
      no_result_display: '',
      selectedmenu: 'frm',
      selectedmenu_2: 'frm_2',
      selectedmenu_1_2: 'frm_1_2',
      subscriptionstatus: '',
      pdfLoading: true,
      chapterLevel: '',
      pdfLoadingAnswer: true,
      level: this.props.params.level,
      showFreePremium: true,
      type: 'question',
      PDFContentMessage: language.LC().PDFContentMessage,
      PDFDownloadType: 'Question',
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.PDFToggleAlert = this.PDFToggleAlert.bind(this);

    this.PDFDownloadAlertModel = this.PDFDownloadAlertModel.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  PDFToggleAlert() {
    this.setState({
      PDF_Alert_status: !this.state.PDF_Alert_status,
    });
  }

  PDFDownloadAlertModel() {
    this.setState({
      PDFDownloadAlertStatus: !this.state.PDFDownloadAlertStatus,
    });
  }

  _getChapters = e => {
    this.context.router.push({
      pathname: '/frm/questionbank/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  _getQuestions = (reading, e) => {
    //console.log("rrrrrrrrrr", reading);

    var final_exam = [];
    var level_store = reading.level;
    var flag_val = false;
    var package_name_1,
      package_name_2 = '';
    var package_all = this.state.selectedmenu_1_2;
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this._runQuestions('free', reading);
          this.setState({ subscriptionstatus: `${language.LC().FREE}` });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
                  level_store,
                  exam_data,
                  examPlanData,
                );
                if (subscriptionStatus) {
                  this.setState({
                    subscriptionstatus: `${language.LC().PAID}`,
                  });
                  this._runQuestions('paid', reading);
                } else {
                  this.setState({
                    subscriptionstatus: `${language.LC().FREE}`,
                  });
                  this._runQuestions('free', reading);
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this._runQuestions('free', reading);
          this.setState({ subscriptionstatus: `${language.LC().FREE}` });
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = FrmSubscriptionCheck.checkFrm(level_store, exam_data);
                // console.log("subscriptionStatus",subscriptionStatus);

                if (subscriptionStatus) {
                  this.setState({
                    subscriptionstatus: `${language.LC().PAID}`,
                  });
                  this._runQuestions('paid', reading);
                } else {
                  this.setState({
                    subscriptionstatus: `${language.LC().FREE}`,
                  });
                  this._runQuestions('free', reading);
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      }
    });
  };

  _runQuestions(subscriptionstatus, reading) {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: this.state.chapterid,
      offset: 0,
      limit: 1,
      subscriptionstatus: subscriptionstatus,
    };

    FD.callAPI(App_data.backend_api + '/frm_question_bank/getQuestions', data).then(resp => {
      if (resp.success) {
        if (resp.questions.length) {
          this.context.router.push({
            pathname: `/frm/questions/${reading.id}/${reading.chapter_no}/${
              reading.reading
            }/${subscriptionstatus}/${this.props.params.chapter}/${reading.level}/${
              this.state.selectedmenufrm
            }`,
            // state: {
            //   token: this.state.token,
            //   idname: this.state.idname,
            //   reading: reading,
            //   chapter: this.props.location.state.chapter,
            //   selectedMenu: this.state.selectedmenufrm,
            //   subscriptionstatus: subscriptionstatus,
            //   level: reading.level,
            // },
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  }

  _beginChapter = (reading, e) => {
    var level_store = reading.level;
    // console.log(level_store)
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this._runCode('free', reading);
          this.setState({ subscriptionstatus: `${language.LC().FREE}` });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
                  level_store,
                  exam_data,
                  examPlanData,
                );
                if (subscriptionStatus) {
                  this.setState({
                    subscriptionstatus: `${language.LC().PAID}`,
                  });
                  this._runCode('paid', reading);
                } else {
                  this.setState({
                    subscriptionstatus: `${language.LC().FREE}`,
                  });
                  this._runCode('free', reading);
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this._runCode('free', reading);
          this.setState({ subscriptionstatus: `${language.LC().FREE}` });
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = FrmSubscriptionCheck.checkFrm(level_store, exam_data);
                if (subscriptionStatus) {
                  this.setState({
                    subscriptionstatus: `${language.LC().PAID}`,
                  });
                  this._runCode('paid', reading);
                } else {
                  this.setState({
                    subscriptionstatus: `${language.LC().FREE}`,
                  });
                  this._runCode('free', reading);
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      }
    });
  };

  _runCode(subscriptionstatus, reading) {
    // console.log('_runCode')
    // console.log(subscriptionstatus)
    // console.log(reading)
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reading_id: reading.id,
      chapter_id: this.state.chapterid,
      offset: 0,
      limit: 1,
      subscriptionstatus: subscriptionstatus,
    };

    FD.callAPI(App_data.backend_api + '/frm_question_bank/getQuestions', data).then(resp => {
      if (resp.success) {
        // console.log(resp.questions)
        if (resp.questions.length) {
          this.context.router.push({
            pathname:
              '/frm/chapter/' +
              this.state.chapterid +
              '/' +
              reading.id +
              '/' +
              resp.questions[0].id +
              '/' +
              reading.level +
              '/' +
              0,
            // state: {
            //   token: this.state.token,
            //   idname: this.state.idname,
            //   reading: reading,
            //   chapter: this.props.location.state.chapter,
            //   offset: 0,
            //   selectedMenu: this.state.selectedmenufrm,
            // },
          });
        } else {
          this.toggleAlert();
        }
      }
    });
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      chapter: this.state.chapterid,
    };
    FD.callAPI(App_data.backend_api + '/frm_question_bank/getReadings', data).then(resp => {
      //console.log(resp);
      if (resp.success) {
        this.setState({
          ValidToken: true,
          readings: resp.readings,
          chapterName: resp.chaptername.chapter_name,
          chapterLevel: resp.chaptername.level,
        });

        if (!resp.readings.length) {
          this.setState({
            no_result_display: `${language.LC().NO_SAVED_QUESTIONS}`,
          });
        }
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    // ----------PDF check---------------
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ showFreePremium: true });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
                  this.state.chapterLevel,
                  exam_data,
                  examPlanData,
                  this.state.type,
                );
                if (subscriptionStatus) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this.setState({ showFreePremium: true });
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = FrmSubscriptionCheck.checkFrm(
                  this.state.chapterLevel,
                  exam_data,
                  this.state.type,
                );
                if (subscriptionStatus) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      }
    });

    // ------------------
  }

  /*
------------------------------
  PDF Question DOWNLOAD Via Email
-------------------------------
*/

  getpdf = async e => {
    if (this.state.pdfLoading == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoadingAnswer == false) {
      alert('Please wait one process is in queue.');
      return;
    }
    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
      chapterLevel: this.state.chapterLevel,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
                  this.state.chapterLevel,
                  exam_data,
                  examPlanData,
                  this.state.type,
                );
                if (subscriptionStatus) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,
                    frmLevel: this.state.chapterLevel,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/frm_question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.PDFDownloadAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.PDFDownloadAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = await FrmSubscriptionCheck.checkFrm(
                  this.state.chapterLevel,
                  exam_data,
                  this.state.type,
                );
                if (subscriptionStatus) {
                  this.setState({
                    pdfLoading: false,
                  });
                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,

                    frmLevel: this.state.chapterLevel,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/frm_question_bank/Q-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.PDFDownloadAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoading: true,
                        PDFDownloadType: 'Question',
                      });
                      this.PDFDownloadAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      }
    });
  };

  /*
--------------------------------------------
  PDF Question & Answer DOWNLOAD Via Email
--------------------------------------------
*/
  getpdfAnswer = async e => {
    if (this.state.pdfLoadingAnswer == false) {
      alert('Download is in progress....');
      return;
    }
    if (this.state.pdfLoading == false) {
      alert('Please wait one process is in queue.');
      return;
    }
    var user_data = {
      token: this.state.token,
      idname: this.state.idname,
      chapterLevel: this.state.chapterLevel,
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                // #261 — partner checkFrm signature is (level, exam_data, examPlanData).
                // This site was passing this.state.type as the 3rd arg → mock-package
                // early-return guard didn't fire → partner with mock-only pkg got
                // PDF QA email anyway. Pass the actual examPlanData object now.
                const examPlanData = resp_exam.examPlan && resp_exam.examPlan[0];
                var subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
                  this.state.chapterLevel,
                  exam_data,
                  examPlanData,
                );
                if (subscriptionStatus) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });
                  // const result = getDeviceDetails();

                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,

                    frmLevel: this.state.chapterLevel,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/frm_question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.PDFDownloadAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.PDFDownloadAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected == '') {
          this.PDFToggleAlert();
        } else {
          var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = await FrmSubscriptionCheck.checkFrm(
                  this.state.chapterLevel,
                  exam_data,
                  this.state.type,
                );
                if (subscriptionStatus) {
                  this.setState({
                    pdfLoadingAnswer: false,
                  });

                  // const result = getDeviceDetails();
                  var dataset = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterId: this.state.chapterid,
                    city: this.state.user_city,
                    country: this.state.user_country,
                    state: this.state.user_state,
                    continent: this.state.user_continent,
                    ip: this.state.user_ip,

                    frmLevel: this.state.chapterLevel,
                  };
                  await FD.callAPI(
                    App_data.backend_api + '/frm_question_bank/QA-PdfDownloadViaEmail',
                    dataset,
                  ).then(response => {
                    if (response.success) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.PDFDownloadAlertModel();
                    } else if (!response.pdf) {
                      this.setState({
                        pdfLoadingAnswer: true,
                        PDFDownloadType: 'Question/Answer',
                      });
                      this.PDFDownloadAlertModel();
                    }
                  });
                } else {
                  this.PDFToggleAlert();
                }
              } else {
                //console.log("fail");
              }
            },
          );
        }
      }
    });
  };

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  render() {
    let readings = this.state.readings;
    let data = '';
    if (this.state.readings.length) {
      data = readings.map((item, index) => (
        <tr key={index}>
           <td>{index + 1}.</td>
          <td>{item.reading}</td>

          <td>
            <span className='tooltip_wrap margin_right_20'>
              <img
                src={App_data.frontend_url + '/img/question_bank/eye_icon.svg'}
                className='pointer_class'
                alt=''
                width='23'
                onClick={this._getQuestions.bind(this, item)}
                id={item.id}
                title=''
              />
              <div className='tootip_box'> {language.LC().VIEW_LIST} </div>
            </span>

            <span className='tooltip_wrap'>
              <img
                src={App_data.frontend_url + '/img/question_bank/open_book_icon.svg'}
                className='pointer_class'
                alt=''
                width='21'
                id={item.id}
                onClick={this._beginChapter.bind(this, item)}
                title=''
              />
              <div className='tootip_box'> {language.LC().BEGIN_CHAPTER} </div>
            </span>
          </td>
        </tr>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{this.state.chapterName}</h1>
          </div>
          <div className='col-md-4 text-md-right margin_bottom_20 question-download-reading-page'>
            <div onClick={this.getpdf.bind(this)} className='status-download-btn margin_right_10'>
              <a className='btn btn-primary  pointer_class pull-right'>
                {this.state.pdfLoading ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}{' '}
                {this.state.showFreePremium ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}
                {this.state.pdfLoading ? language.LC().Download_Question : '  please wait...'}
              </a>
            </div>
            <div
              onClick={this.getpdfAnswer.bind(this)}
              className='status-download-btn margin_right_10'
            >
              <a className='btn btn-primary  pointer_class pull-right'>
                {this.state.pdfLoadingAnswer ? (
                  <i className='fa fa-download' aria-hidden='true' />
                ) : (
                  <i className='fa fa-spinner fa-spin' aria-hidden='true' />
                )}{' '}
                {this.state.showFreePremium ? (
                  <div className='premium-download'>{language.LC().PREMIUM}</div>
                ) : null}
                {this.state.pdfLoadingAnswer
                  ? language.LC().Download_Question_Answer
                  : '  please wait...'}
              </a>
            </div>

            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getChapters}
            >
              {language.LC().CHANGE_TOPIC}
            </button>
          </div>
        </div>

        <div className='row'>
          <div className='col-md-12'>
            <div className='card height_70vh'>
              <div className='card-header'>
                {language.LC().CHAPTER} {this.props.params.chapter.id}{' '}
                {this.props.params.chapter.chapter_name} {language.LC().READINGS}
              </div>

              <div className='table_responsive_wrapper'>
                <div className='table-responsive'>
                  <table className='table_white_bg table'>
                    <thead>
                      <tr className='border_top_0'>
                        <th width='90'>#</th>
                        <th>{language.LC().READING}</th>
                        <th>{language.LC().ACTION}</th>
                      </tr>
                    </thead>
                    <tbody>{data}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.alert_status}
          toggle={this.toggleAlert}
          className={'modal-primary ' + this.props.className}
        >
          <ModalHeader toggle={this.toggleAlert}>{this.state.MessageTitle}</ModalHeader>
          <ModalBody>
            <div className='d-flex flex-column'>
              <div> {this.state.MessageContent}</div>
              <div className='text-right'>
                {' '}
                <Button color='primary' onClick={this.toggleAlert}>
                  {' '}
                  {language.LC().OK}{' '}
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.PDFToggleAlert.bind(this)}
          alert_status={this.state.PDF_Alert_status}
          MessageContent={this.state.PDFMessageContent}
        />

        <PDFModelComponent
          type={this.state.PDFDownloadType}
          pdfAlertModel={this.PDFDownloadAlertModel.bind(this)}
          pdfAlert={this.state.PDFDownloadAlertStatus}
          PDFContentMessage={this.state.PDFContentMessage}
        />
      </div>
    );
  }
}

export default FrmReadings;



// WEBPACK FOOTER //
// ./src/views/FRM/FrmQueBank/FrmReadings/FrmReadings.js